import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

// components
import { FavoritesItem } from '../../components/global/FavoriteIcons/FavoritesItem';
import { FavoritesProvider } from '../../components/global/FavoriteIcons/FavoritesProvider';
import { addForceFavoriteRefetchHandler } from 'dibs-buyer-layout/exports/loginHandlers';

// helpers
import { locations } from '../../utils/tracking/shared/favoritesTracking';
import { useFragment, graphql } from 'react-relay';

export function PdpSharedSidebarFavorites(props) {
    // Todo: Directly pass in userId
    const { isClient, environment, userId, item: itemRef } = props;

    const item = useFragment(
        graphql`
            fragment PdpSharedSidebarFavorites_item on Item {
                ...FavoritesItem_item
                serviceId
                isAuctionEnabled
            }
        `,
        itemRef
    );
    const [shouldFavoritesProviderRefetch, setShouldFavoritesProviderRefetch] = useState(false);

    useEffect(() => {
        addForceFavoriteRefetchHandler(() => {
            setShouldFavoritesProviderRefetch(true);
        });
    }, [setShouldFavoritesProviderRefetch]);

    return (
        <FavoritesProvider
            environment={environment}
            location={item?.isAuctionEnabled ? locations.AUCTION_PDP : locations.SIDEBAR}
            disable={!isClient}
            userId={userId}
            itemIds={[item?.serviceId]}
            shouldAutoFavorite
            shouldRefetch={shouldFavoritesProviderRefetch}
        >
            {
                // eslint-disable-next-line
                ({ props: renderProps }) => (
                    <FavoritesItem
                        {...renderProps}
                        item={item}
                        itemImage={props.itemImage}
                        wrapperClass={props.wrapperClass}
                        heartIconWrapperClass={props.heartIconWrapperClass}
                        folderIconWrapperClass={props.folderIconWrapperClass}
                    />
                )
            }
        </FavoritesProvider>
    );
}

PdpSharedSidebarFavorites.propTypes = {
    userId: PropTypes.string,
    isClient: PropTypes.bool.isRequired,
    wrapperClass: PropTypes.string,
    heartIconWrapperClass: PropTypes.string,
    folderIconWrapperClass: PropTypes.string,
    environment: PropTypes.object.isRequired,
    itemImage: PropTypes.string,
    item: PropTypes.object.isRequired,
};
